import { useEffect, useRef } from 'react'
import { trackEvent } from '@/lib/analytics'

const SPROUT_API_URL = 'https://c.sproutvideo.com/player_api.js'
const SPROUT_VIDEO_ID = '069adbb51f1be4c28c'

declare global {
  interface Window {
    SV?: {
      Player: (options: { videoId: string }) => {
        bind(event: string, handler: () => void): void
        unbind?: (event: string, handler: () => void) => void
        destroy?: () => void
      }
    }
  }
}

const TrailerSection = () => {
  const hasTrackedPlay = useRef(false)

  useEffect(() => {
    let cancelled = false
    let player: {
      bind(event: string, handler: () => void): void
      unbind?: (event: string, handler: () => void) => void
      destroy?: () => void
    } | undefined
    let scriptElement: HTMLScriptElement | undefined

    const bindPlayer = () => {
      if (cancelled || !window.SV?.Player) return
      player = window.SV.Player({ videoId: SPROUT_VIDEO_ID })
      const handlePlay = () => {
        if (hasTrackedPlay.current) return
        hasTrackedPlay.current = true
        trackEvent('film_click', {
          site: 'spoke',
          film: 'spoke',
          action: 'watch',
          placement: 'trailer',
          provider: 'sproutvideo',
        })
      }
      player.bind('play', handlePlay)
      cleanup = () => {
        player?.unbind?.('play', handlePlay)
        player?.destroy?.()
      }
    }

    let cleanup = () => {}
    const existingScript = document.querySelector<HTMLScriptElement>(`script[src="${SPROUT_API_URL}"]`)
    if (window.SV?.Player) {
      bindPlayer()
    } else if (existingScript) {
      scriptElement = existingScript
      existingScript.addEventListener('load', bindPlayer)
    } else {
      const script = document.createElement('script')
      script.src = SPROUT_API_URL
      script.async = true
      script.addEventListener('load', bindPlayer)
      document.head.appendChild(script)
      scriptElement = script
    }

    return () => {
      cancelled = true
      scriptElement?.removeEventListener('load', bindPlayer)
      cleanup()
    }
  }, [])

  return (
    <section id="trailer" className="relative w-full bg-black">
      <div style={{ position: 'relative', height: 0, paddingBottom: '41.875%' }}>
        <iframe
          className="sproutvideo-player"
          src="https://videos.sproutvideo.com/embed/069adbb51f1be4c28c/52ce6c8966b3405f?playerColor=000000&seekBar=false&settingsButton=false&loop=true"
          style={{ position: 'absolute', width: '100%', height: '100%', left: 0, top: 0 }}
          frameBorder={0}
          allowFullScreen
          referrerPolicy="no-referrer-when-downgrade"
          title="Video Player"
        ></iframe>
      </div>
      <div className="flex justify-center py-10 bg-black">
        <a
          href="https://www.instagram.com/spoke.movie/"
          onClick={() => trackEvent('social_click', { site: 'spoke', film: 'spoke', platform: 'instagram', placement: 'trailer' })}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-3 font-bebas text-2xl tracking-widest text-white border border-white px-10 py-4 hover:bg-white hover:text-black transition-colors"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="currentColor">
            <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
          </svg>
          FOLLOW US ON INSTAGRAM
        </a>
      </div>
    </section>
  )
}

export default TrailerSection
